module.exports = __webpack_public_path__ + "img/funnel-fdisp-grezza-plus10-2022.e54e70c3.svg";